import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import LiveMap from './LiveMap';
import ToastContext from '../contexts/ToastContext';

export default function MapPage() {
  const [selectedEventId, setSelectedEventId] = useState(null);
  const navigate = useNavigate();
  const toast = useContext(ToastContext);

  const handleMarkerClick = (marker) => {
    console.log('Marker clicked:', marker);
    // Can be used for analytics or additional features
  };

  const handleEventSelect = (eventId) => {
    setSelectedEventId(eventId);
    navigate(`/events/${eventId}`);
  };

  return (
    <div className="map-page">
      <LiveMap 
        onMarkerClick={handleMarkerClick}
        onEventSelect={handleEventSelect}
      />
    </div>
  );
}
